import React, { Component } from "react";
import { getPacienteFila, getPacienteFila2 } from "../Libs/filaProcedimentos";
import PreLoaderWidget from "../components/Loader";
import CrudBar from "../gb-components/CrudBar";
import { getLoggedInUser } from "../helpers/authUtils";
import { FilaProcedimentoEnum } from "../helpers/enums";
import { Row } from "reactstrap";
import ModalComponent from "../components/Modal";
import DadosFila from "../Views/FilaProcedimentos/dadosFila";
import moment from "moment";

class FilaPaciente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: getLoggedInUser(),
            fila: [],
            loading: true,
            modalDetalhe: false,
            editId: null,
        };
    }

    async componentDidMount() {
        let filaTodosAbertos = await getPacienteFila(this.state.user.cpf)
        console.log(filaTodosAbertos)
        this.setState({ fila: filaTodosAbertos, loading: false })
    }

    openDetalheModal(item) {
        this.setState({ modalDetalhe: true, editId: item });
    }

    closeModal = () => {
        this.setState({
            editId: null,
            modalDetalhe: false
        })
    }

    render() {
        return (
            <React.Fragment>
                <ModalComponent
                    openModal={this.state.modalDetalhe}
                    closeModal={this.closeModal}
                    auto={true}
                >
                    <DadosFila
                        item={this.state.editId}
                    />
                </ModalComponent>

                <CrudBar
                    title="Fila de Procedimentos"
                    breadcrumb={["Globalbrain", "Fila de Procedimentos"]}
                />

                <div className="gb-page">
                    <div className="table-responsive table-striped">
                        <table className="table gb-table">
                            <thead>
                                <tr>
                                    <th scope="col">Nº na fila</th>
                                    <th scope="col">Dias espera</th>
                                    <th scope="col">Procedimento</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Fora Mun.</th>
                                    <th scope="col">Data Proc.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (<div className="text-center"><PreLoaderWidget /></div>) :
                                    this.state.fila && this.state.fila.length === 0 ?
                                        <Row><h5 style={{ margin: "auto" }}>Nenhuma informação para ser exibida</h5></Row>
                                        : this.state.fila.map(
                                            (item, index) => {
                                                return (
                                                    <tr key={index}
                                                        className="text-center"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => this.openDetalheModal(item)}>
                                                        <td className="text-center">{item.seqFila == 0 ? '' : item.seqFila}</td>
                                                        <td className="text-center">{item.diasEspera}</td>
                                                        <td className="text-center">{item.procedimento.descricao}</td>
                                                        <td className="text-center"
                                                            style={{
                                                                color: item.status === FilaProcedimentoEnum.ProcedimentoAgendado ? 'green' :
                                                                    item.status === FilaProcedimentoEnum.Recusado ? 'red' : 'orange'
                                                            }}>{item.status}</td>
                                                        <td className="text-center">{item.fora_municipio ? "Sim" : "Não"}</td>
                                                        <td className="text-center">{moment(item.dataFila).format('DD/MM/YYYY')}</td>
                                                    </tr>
                                                )
                                            }
                                        )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default FilaPaciente;